// Remove when Prosemirror is enabled for all users on edit.

const LegacyEditorHandle = id => ({
   legacy: true,
   get value() {
      return this.el ? $(id).get('value') : '';
   },
   get text() {
      return this.el ? $(id).get('value') : '';
   },
   get el() {
      return $(id);
   },
   get editable() {
      return $(id);
   },
});

export default LegacyEditorHandle;
